module.exports = __webpack_public_path__ + "static/img/Digitales.2d0b0d49.png";